import React from 'react';
import MyAccountCard from './MyAccountCard';
import MyAccountCardField from './MyAccountCardField';

export default class MyAccountUnitsCard extends MyAccountCard {
    title = __('Units')
    endpoint = 'SaveUnits'

    state = {
        units: this.props.model.units.map(x => x.units.model || '')
    }

    onCategoryUnitChange = (categoryIndex, value) => {
        let units = this.state.units
        units[categoryIndex] = parseInt(value)

        this.setState({
            units: units
        })
    }

    renderBody() {
        return (
            <div className="my-account-units-card">
                {this.props.model.units.map((category, categoryIndex) => (
                    <MyAccountCardField key={category.name} label={category.name}>
                        <select onChange={e => this.onCategoryUnitChange(categoryIndex, e.target.value)}
                                value={this.state.units[categoryIndex]}>
                            {category.units.items.map(unit => (
                                <option key={unit.value} value={unit.value}>{unit.text}</option>
                            ))}
                        </select>
                    </MyAccountCardField>
                ))}
            </div>
        )
    }

    getModel() {
        return this.state.units
    }
}
